import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { SupportAttachment } from './support-attachment';
export { SupportAttachment };
import { supportAttachmentSchema } from '@schemas/business-objects/support-attachment';
import { AccountFormGroup } from './account-form-group';
import { SupportCaseFormGroup } from './support-case-form-group';
import { SupportCommentFormGroup } from './support-comment-form-group';
import { UserFormGroup } from './user-form-group';

export class SupportAttachmentFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    fileName: SchemaFormControl;
    mimeType: SchemaFormControl;
    base64Content: SchemaFormControl;
    createdAt: SchemaFormControl;
    updatedAt: SchemaFormControl;
    caseId: SchemaFormControl;
    case: SupportCaseFormGroup;
    accountId: SchemaFormControl;
    account: AccountFormGroup;
    commentId: SchemaFormControl;
    comment: SupportCommentFormGroup;
    userId: SchemaFormControl;
    user: UserFormGroup;
    createdById: SchemaFormControl;
    createdBy: UserFormGroup;
    updatedById: SchemaFormControl;
    updatedBy: UserFormGroup;
  };

  declare value: Partial<SupportAttachment>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(supportAttachmentSchema, SupportAttachment, data, options);
  }

  get object(): SupportAttachment {
    return new SupportAttachment(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'case':
        return new SupportCaseFormGroup();
      case 'account':
        return new AccountFormGroup();
      case 'comment':
        return new SupportCommentFormGroup();
      case 'user':
        return new UserFormGroup();
      case 'createdBy':
        return new UserFormGroup();
      case 'updatedBy':
        return new UserFormGroup();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<SupportAttachment[]> {
    return SupportAttachment.find(filter);
  }

  static async findOne(filter?: any): Promise<SupportAttachment | null> {
    return SupportAttachment.findOne(filter);
  }

  static async findById(id: number, filter?: any): Promise<SupportAttachment> {
    return SupportAttachment.findById(id, filter);
  }

  static async create(
    data: Partial<SupportAttachment>,
  ): Promise<SupportAttachment> {
    return SupportAttachment.create(data as any);
  }

  static async updateById(
    id: number,
    updates: Partial<SupportAttachment>,
  ): Promise<SupportAttachment> {
    return SupportAttachment.updateById(id, updates as any);
  }

  static async deleteById(id: number): Promise<boolean> {
    return SupportAttachment.deleteById(id);
  }
}

export class SupportAttachmentFormArray extends PersistedFormArray {
  declare controls: SupportAttachmentFormGroup[];

  readonly entityName = 'SupportAttachment' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(supportAttachmentSchema, SupportAttachment, options);
  }

  protected override createItemGroup() {
    return new SupportAttachmentFormGroup();
  }

  get array(): SupportAttachment[] {
    return this.controls.map(
      (group: SupportAttachmentFormGroup) => group.object,
    );
  }
}

export class SupportAttachmentPersistedArray extends PersistedArray<SupportAttachment> {
  readonly entityName = 'SupportAttachment' as const;

  constructor(options?: PersistedArrayOptions) {
    super(SupportAttachment, options);
  }
}
